import { yupResolver } from '@hookform/resolvers/yup'
import AppRegistrationIcon from '@mui/icons-material/AppRegistration'
import ContactMailIcon from '@mui/icons-material/ContactMail'
import LoginIcon from '@mui/icons-material/Login'
import PasswordIcon from '@mui/icons-material/Password'
import { LoadingButton } from '@mui/lab'
import {
  Container,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import { Box } from '@mui/system'
import { useAppDispatch } from 'app/hooks'
import { UIAction } from 'app/slices/UI'
import { AxiosClientError } from 'interface'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { Link, useLocation } from 'react-router-dom'
import axiosClient from 'utils/axiosClient'
import * as yup from 'yup'

interface FormInput {
  id: string
  password: string
}
const schema = yup.object({
  id: yup.string().required(),
  password: yup.string().required(),
})
export default function Login() {
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(false)
  const urlQuery = new URLSearchParams(useLocation().search)
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInput>({
    resolver: yupResolver(schema),
    defaultValues: {
      id: '',
      password: '',
    },
  })

  const onSubmit: SubmitHandler<FormInput> = async (data) => {
    const { id, password } = data
    try {
      setLoading(true)
      const { data } = await axiosClient.post('/auth/user/login', {
        id,
        password,
      })
      dispatch(UIAction.setAuth(data))
    } catch (error) {
      const { status } = error as AxiosClientError
      const msg = 'ログインできませんでした。'

      enqueueSnackbar(msg, {
        variant: 'error',
      })
      status === 423 &&
        dispatch(
          UIAction.setNotice(
            'アカウントをロックしました。しばらくたってからログインしてください。'
          )
        )
    } finally {
      setLoading(false)
    }
  }
  return (
    <Box>
      <Container
        maxWidth="xs"
        component="form"
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit(onSubmit)}
        className="flex-1 flex flex-col items-center justify-center"
      >
        <Typography align="center" variant="h4" component="h2">
          ログイン
        </Typography>
        <TextField
          autoFocus
          required
          margin="dense"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <ContactMailIcon color="primary" />
              </InputAdornment>
            ),
          }}
          label="ID"
          fullWidth
          variant="standard"
          {...register('id')}
          error={'id' in errors}
        />

        <TextField
          required
          margin="dense"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PasswordIcon color="primary" />
              </InputAdornment>
            ),
          }}
          label="パスワード"
          type="password"
          autoComplete="on"
          fullWidth
          variant="standard"
          {...register('password')}
          error={'password' in errors}
        />
        <Stack justifyContent="center" direction="row">
          <LoadingButton
            disabled={Object.keys(errors).length > 0}
            variant="contained"
            type="submit"
            sx={{
              mt: 4,
              px: 4,
              minWidth: 300,
            }}
            loading={loading}
            color={'primary'}
            loadingPosition="start"
            startIcon={<LoginIcon />}
          >
            ログイン
          </LoadingButton>
        </Stack>
      </Container>
      <Stack justifyContent="center" direction="row">
        <Link to={`/register?${urlQuery}`}>
          <LoadingButton
            disabled={Object.keys(errors).length > 0}
            variant="contained"
            type="submit"
            sx={{
              mt: 4,
              px: 4,
              minWidth: 300,
            }}
            loading={loading}
            color={'secondary'}
            loadingPosition="start"
            startIcon={<AppRegistrationIcon />}
          >
            新規作成
          </LoadingButton>
        </Link>
      </Stack>
    </Box>
  )
}
